import { AppError } from './libraries/app-error';

export class NotFoundError extends AppError {}
